import { CheckoutActions } from '../actions';
import { CustomCheckoutState } from '../checkout-state';

export const initialState: CustomCheckoutState['redirectedToPaymentPage'] = {
  value: false,
};

export function reducer(
  state = initialState,
  action: CheckoutActions.SetRedirectedToPaymentPage,
): CustomCheckoutState['redirectedToPaymentPage'] {
  switch (action.type) {
    case CheckoutActions.SET_REDIRECTED_TO_PAYMENT_PAGE: {
      return {
        value: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
